import { makeStyles } from '@material-ui/core';
import Colors from '../../../constants/Colors';

export default makeStyles(() => ({
  containerClass: (props: any) => ({
    border: `1px solid ${
      props?.error ? Colors.DANGER_LIGHT_COLOR_3 : 'rgba(0, 0, 0, 0.25)'
    }`,
    borderRadius: '0.25rem',
    padding: '0rem 1rem 0',
    '&:focus-within': {
      border: `1px solid ${Colors.PRIMARY_COLOR}`,
    },
  }),
  inputClass: (props: any) => ({
    position: 'relative',
    '&>.MuiInput-root': {
      '&::before': {
        display: 'none',
      },
      '&::after': {
        display: 'none',
      },
    },
    '&>label': {
      top: -8,
      backgroundColor: Colors.WHITE,
      paddingRight: '0.5rem',
      color: `${
        props?.error ? Colors.DANGER_LIGHT_COLOR_3 : Colors.GRAY_LIGHT_SHADE_5
      }`,
    },
  }),
  errorText: {
    margin: '0 0.875rem',
    fontSize: '0.625rem',
    fontWeight: 400,
    lineHeight: '1.125rem',
    color: Colors.DANGER_LIGHT_COLOR_3,
  },
}));
